import { request } from '@h3/request';
import { H3 } from '@h3/types';
import { Util } from '@h3/h3common';

/** 下载示例模板 */
export const getImportTemplate = () => {
    const params = {
        ActionName: 'GetImportTemplate',
    };
    return request<H3.Http.Response.H3ResponseV2<H3.Import.Response.IGetImportTemplate>>('/ExcelImport/OnAction', {
        method: 'post',
        requestType: 'form',
        data: {
            PostData: Util.JSON.stringify(params),
        },
    });
};

/** 下载示例模板 */
export const downloadImportTemplate = (params: {
    ActionName: string;
    SchemaCode: string;
    ActionGuid: string;
    ImportOption: string;
}) => {
    return request<H3.Http.Response.H3ResponseV2<H3.Import.Response.IGetImportTemplate>>('/ExcelExport/OnAction', {
        method: 'post',
        requestType: 'form',
        data: {
            PostData: Util.JSON.stringify(params),
        },
    });
};

/** 检查excel属性字段 */
export const checkPropertyFields = (params: H3.Import.Request.ICheckPropertyFields) => {
    return request<H3.Http.Response.H3ResponseV2<H3.Import.Response.ICheckPropertyFields>>('/ExcelImport/OnAction', {
        method: 'post',
        requestType: 'form',
        data: {
            PostData: Util.JSON.stringify(params),
        },
    });
};

/** 根据sheetName获取excel表单数据 */
export function getSheetData(params: H3.Import.Request.IGetSheetData) {
    return request<H3.Http.Response.H3ResponseV2<H3.Import.Response.IGetSheetData>>('/ExcelImport/OnAction', {
        method: 'post',
        requestType: 'form',
        data: {
            PostData: Util.JSON.stringify(params),
        },
    });
}

/** excel导入创建表单schema */
export function generateSchema(params: H3.Import.Request.IGenerateSchema) {
    return request<H3.Http.Response.H3ResponseV2<H3.Import.Response.IGenerateSchema>>('/ExcelImport/OnAction', {
        method: 'post',
        requestType: 'form',
        data: {
            PostData: Util.JSON.stringify(params),
        },
    });
}

/** excel导入获取导入进度 */
export function getImportProgress(params: H3.Import.Request.IGetGenerateSchemaProgress) {
    return request<H3.Http.Response.H3ResponseV2<H3.Import.Response.IGetGenerateSchemaProgress>>(
        '/ExcelImport/OnAction',
        {
            method: 'post',
            requestType: 'form',
            data: {
                PostData: Util.JSON.stringify(params),
            },
        },
    );
}

/** 中断excel导入 */
export function abortImport(params: H3.Import.Request.IAbortGenerateSchemaImport) {
    return request<H3.Http.Response.H3ResponseV2>('/ExcelImport/OnAction', {
        method: 'post',
        requestType: 'form',
        data: {
            PostData: Util.JSON.stringify(params),
        },
    });
}

/** 清除缓存 */
export function clearImportCache(params: H3.Import.Request.IClearCache) {
    return request<H3.Http.Response.H3ResponseV2>('/ExcelImport/OnAction', {
        method: 'post',
        requestType: 'form',
        data: {
            PostData: Util.JSON.stringify(params),
        },
    });
}

export function getLogByTaskId(taskId: string) {
    return request<H3.Http.Response.H3Response<H3.Import.Response.RecordDetailModel>>(
        '/v1/bizlog/action/import/bytaskId',
        {
            method: H3.Http.MethodType.GET,
            params: { taskId },
        },
    );
}

// 添加导入异步任务
export function addImportTask(importTaskRequest: H3.Import.Request.IAddImportTaskParams) {
    const url = '/v1/dataImport/addImportTask';
    return request<H3.Http.Response.H3Response<string>>(url, {
        method: H3.Http.MethodType.POST,
        data: importTaskRequest,
    });
}

/**
 * 获取导入状态
 * @param schemaCode
 * @param asyncTaskId
 * @returns
 */
export const getImportStatus = (schemaCode: string, asyncTaskId: string, fromNum = 0) => {
    const postData = {
        ActionName: 'ImportData',
        SchemaCode: schemaCode,
        ImportGuid: asyncTaskId,
        FromNum: fromNum,
    };
    return request<H3.Http.Response.H3ResponseV2<any>>('/ExcelImport/OnAction', {
        method: 'post',
        requestType: 'form',
        data: {
            PostData: Util.JSON.stringify(postData),
        },
    });
};

// 获取导入历史记录
// export const getImportTaskRecords = (type: number, schemaCode: string, taskIds: string[], recentHours = 72) => {
//     const url = '/v1/dataimport/LoadTaskRecords';
//     return request<H3.Http.Response.H3Response<H3.Import.Response.ITaskRecordModel[]>>(url, {
//         data: {
//             Type: type,
//             TaskIds: taskIds,
//             RecentHours: recentHours,
//             SchemaCode: schemaCode,
//         },
//         method: H3.Http.MethodType.POST,
//     });
// };

// 取消等待中的导入导出任务
export const getWaitingTask = (taskId: string) =>
    request<H3.Http.Response.H3Response<any>>(`/h3/v1/importOrExport/getWaitingTaskInfos?actionGuid=${taskId}`, {
        method: 'get',
    });

// 取消等待中的导入导出任务
// export const cancelWaitingTask = (taskId: string) =>
//     request<H3.Http.Response.H3Response<boolean>>(`/v1/dataimport/CancelWaitingTask?taskId=${taskId}`, {
//         method: 'get',
//     });

// 获取导入报告下载地址
export const getImportReportUrl = (taskId: string) =>
    request<H3.Http.Response.H3Response<string>>(`/v1/dataimport/GetImportDownUrl?taskId=${taskId}`, {
        method: 'get',
    });

// 超时任务重试
// export function retryTasks(taskIds: string[]) {
//     return request<H3.Http.Response.H3Response<boolean>>('/v1/dataimport/RetryTimeoutTasks', {
//         method: H3.Http.MethodType.POST,
//         data: taskIds,
//     });
// }

// 获取表单的全局导入配置
export function getImportConfig(schemaCode: string) {
    const url = `/v1/formconfig/importconfig?schemaCode=${schemaCode}`;
    return request<H3.Http.Response.H3Response<H3.Import.Response.IImportConfigResponse>>(url, {
        method: 'get',
    });
}
